export default {
    getUser() {
        return axios.get('/api/member/user');
    },
    updateUser(data) {
        return axios.post('/api/member/user', data, {headers: {'content-type': 'multipart/form-data'}});
    },
    eftUpdate(accountName, accountBSB, accountNumber) {
        return axios.post('/api/member/eft', { 'acctname': accountName , 'acctbsb': accountBSB, 'acctnumber': accountNumber});
    },
};
